export const SIDEBAR_MOTION_TRANSITION = { duration: 0.3, ease: [0.25, 0.1, 0.25, 1] as const }

/** CSS counterpart of SIDEBAR_MOTION_TRANSITION; keep both in sync. */
export const SIDEBAR_CSS_TRANSITION = 'duration-300 ease-[cubic-bezier(0.25,0.1,0.25,1)]'

/** Important variant for MUI components, whose unlayered styles otherwise override Tailwind utilities. */
export const SIDEBAR_CSS_TRANSITION_IMPORTANT = 'duration-300! ease-[cubic-bezier(0.25,0.1,0.25,1)]!'
